import { api } from "./client";

export interface PasskeyChallenge {
  challenge: string;
  rpId: string;
  expiresIn: number;
}

export async function getPasskeyChallenge(credentialId?: string): Promise<PasskeyChallenge> {
  const path = credentialId
    ? "/auth/passkey/challenge?credentialId=" + encodeURIComponent(credentialId)
    : "/auth/passkey/challenge";
  return api.get<PasskeyChallenge>(path);
}

export interface RegisterPasskeyRequest {
  credentialId: string;
  publicKeyX: string;
  publicKeyY: string;
  name?: string;
}

export interface RegisterPasskeyResponse {
  success: boolean;
  message: string;
  walletAddress?: string;
}

export async function registerPasskey(data: RegisterPasskeyRequest): Promise<RegisterPasskeyResponse> {
  return api.post<RegisterPasskeyResponse>("/auth/passkey/register", data);
}

export interface WalletAddressResponse {
  success: boolean;
  walletAddress: string;
  credentialId: string;
}

export async function getWalletAddress(credentialId: string): Promise<WalletAddressResponse> {
  return api.get<WalletAddressResponse>("/auth/passkey/wallet?credentialId=" + encodeURIComponent(credentialId));
}

export interface LoginPasskeyRequest {
  credentialId: string;
  authenticatorData: string;
  clientDataJSON: string;
  signature: string;
  challenge: string;
}

export interface LoginPasskeyResponse {
  success: boolean;
  token?: string;
  user?: {
    id: string;
    email?: string | null;
    name?: string | null;
  };
}

export async function loginWithPasskey(data: LoginPasskeyRequest): Promise<LoginPasskeyResponse> {
  return api.post<LoginPasskeyResponse>("/auth/passkey/login", data);
}

export interface Passkey {
  id: string;
  credentialId: string;
  name: string | null;
  counter: number;
  createdAt: string;
  lastUsedAt: string | null;
}

export interface ListPasskeysResponse {
  passkeys: Passkey[];
}

export async function listPasskeys(): Promise<ListPasskeysResponse> {
  return api.get<ListPasskeysResponse>("/auth/passkey/list");
}

export interface DeletePasskeyResponse {
  success: boolean;
}

export async function deletePasskey(id: string): Promise<DeletePasskeyResponse> {
  return api.delete<DeletePasskeyResponse>("/auth/passkey/" + id);
}
